/**
 * Compute pot distribution for team match payouts.
 *
 * @param {Array<{matchTeam: {id: string}, points: number}>} teamStandings – sorted desc by points
 * @param {{preset: string, splits: number[]}} payoutConfig
 * @param {number} totalPot
 * @returns {Map<string, {amount: number, placement: number, tied: boolean}>}
 */
export function computePotDistribution(teamStandings, payoutConfig, totalPot) {
  const result = new Map()
  if (!teamStandings?.length || !payoutConfig?.splits?.length || !totalPot) return result

  const splits = payoutConfig.splits // percentages, e.g. [80, 20]

  // Assign placements handling ties
  let placement = 1
  let i = 0
  while (i < teamStandings.length) {
    // Find all teams tied at this point total
    const tiedGroup = [i]
    while (i + 1 < teamStandings.length && teamStandings[i + 1].points === teamStandings[i].points) {
      i++
      tiedGroup.push(i)
    }

    // Sum the split percentages for the placements this tied group spans
    let combinedPct = 0
    for (let p = placement; p < placement + tiedGroup.length; p++) {
      if (p - 1 < splits.length) {
        combinedPct += splits[p - 1]
      }
    }

    // Each tied team gets an equal share
    const perTeamAmount = Math.round((combinedPct / tiedGroup.length / 100) * totalPot)
    const tied = tiedGroup.length > 1

    for (const idx of tiedGroup) {
      result.set(teamStandings[idx].matchTeam.id, {
        amount: perTeamAmount,
        placement,
        tied,
      })
    }

    placement += tiedGroup.length
    i++
  }

  return result
}
